import { TFunction } from 'i18next'

import { OpenGraph } from '@/components/utils/Meta'

import RémunérationIndépendantPreview from '../indépendant/RémunérationIndépendantPreview.png'

export function eurlOpenGraph(t: TFunction): OpenGraph {
	return {
		title: t(
			'pages.simulateurs.eurl.meta.ogTitle',
			"Rémunération du dirigeant d'EURL : un simulateur pour connaître votre salaire net"
		),
		description: t(
			'pages.simulateurs.eurl.meta.ogDescription',
			'En tant que dirigeant assimilé-salarié, calculez immédiatement votre revenu net après impôt à partir du total alloué à votre rémunération.'
		),
		image: RémunérationIndépendantPreview,
	}
}
